import { useCurrency } from '@/contexts/CurrencyContext';

// Display price in customer's local currency ONLY
const DualPrice = ({ amount, showLocal = true, className = '' }) => {
  const { formatLocalPrice, loading } = useCurrency();
  
  if (loading) {
    return <span className={className}>...</span>;
  }

  const localPrice = formatLocalPrice(amount);

  return (
    <span className={className}>
      <span className="font-semibold">{localPrice}</span>
    </span>
  );
};

// Compact version for product cards - shows local currency only
export const CompactDualPrice = ({ amount, originalAmount, className = '', ...rest }) => {
  const { formatLocalPrice, loading } = useCurrency();
  
  if (loading) {
    return <div className={className}>...</div>;
  }
  
  const price = formatLocalPrice(amount);
  const original = originalAmount ? formatLocalPrice(originalAmount) : null;
  
  return (
    <div className={className} {...rest}>
      <div className="flex items-center gap-2">
        <span className="font-semibold">{price}</span>
        {original && (
          <span className="text-gray-400 line-through text-sm">{original}</span>
        )}
      </div>
    </div>
  );
};

// Checkout price display showing all relevant currencies
export const CheckoutPrices = ({ amount, billingCountryCode, className = '' }) => {
  const { getCheckoutPrices, loading } = useCurrency();
  
  if (loading) {
    return <span className={className}>${amount.toFixed(2)}</span>;
  }

  const prices = getCheckoutPrices(amount, billingCountryCode);

  return (
    <div className={className}>
      <div className="font-bold text-lg">{prices.usd.formatted}</div>
      {prices.ngn && (
        <div className="text-gray-600 text-sm">
          ≈ {prices.ngn.formatted} <span className="text-xs">(NGN)</span>
        </div>
      )}
      {prices.detected && (
        <div className="text-gray-600 text-sm">
          ≈ {prices.detected.formatted} <span className="text-xs">({prices.detected.code})</span>
        </div>
      )}
      {prices.billing && (
        <div className="text-gray-600 text-sm">
          ≈ {prices.billing.formatted} <span className="text-xs">(Billing: {prices.billing.code})</span>
        </div>
      )}
    </div>
  );
};

export default DualPrice;
